import { render, staticRenderFns } from "./Panic.vue?vue&type=template&id=01f57722&scoped=true&"
import script from "./Panic.vue?vue&type=script&lang=js&"
export * from "./Panic.vue?vue&type=script&lang=js&"
import style0 from "./Panic.vue?vue&type=style&index=0&id=01f57722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f57722",
  null
  
)

export default component.exports